export default function NotFoundPage() {
  return <div className="not-found-background" />;
}
